export const SUPPORTED_TYPES = {
  text: 'text',
  number: 'number',
};

export const SUPPORTED_OPERATORS = {
  gt: 'Is Greater Than ',
  gte: 'Is Greater Or Equal To ',
  lt: 'Is Less Than ',
  lte: 'Is Less Than Or Equal To ',
  eq: 'Is Equal To ',
  neq: 'Is Not Equal To ',
  contains: 'Contains ',
  empty: 'Is Empty',
  nempty: 'Is Not Empty',
};

export const FIXED_VALUE_OPERATORS = {
  empty: {
    value: '',
  },
  nempty: {
    value: '',
  },
};

export const SUPPORTED_VARIABLES = {
  page_url: {
    label: 'Page URL',
    type: 'text',
    metaKeys: [],
  },
  no_of_visits: {
    label: 'No. of Visits',
    type: 'number',
    metaKeys: [],
  },
  query_param: {
    label: 'Query Params',
    type: 'text',
    metaKeys: [
      {
        key: 'key',
        title: 'Key',
        type: 'string',
      },
    ],
  },
  time_on_page: {
    label: 'Time on Page',
    type: 'number',
    metaKeys: [],
  },
  form_field: {
    type: 'text',
    label: 'Form Field',
    metaKeys: [
      {
        key: 'field_id',
        title: 'Field Id',
        type: 'string',
      },
    ],
  },
};

export const SUPPORTED_OPERATORS_BY_TYPE = {
  [SUPPORTED_TYPES.text]: ['eq', 'neq', 'contains', 'empty', 'nempty'],
  [SUPPORTED_TYPES.number]: ['gt', 'gte', 'lt', 'lte', 'eq', 'neq'],
};

// Number of quick reply allowed in bot prompt variant
export const PROMPT_MAX_QUICK_REPLY = 4;
// Number of characters allowed in bot prompt variant title
export const PROMPT_MAX_TITLE_LENGTH = 108;
// Number of characters allowed in quick reply title
export const PROMPT_MAX_QUICK_REPLY_TITLE_LENGTH = 35;
